import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { MYSQL, REST_API } from 'drapcode-constant';
import {
  apiTypeImages,
  snakeCaseToTitleCase,
  dynamicSort,
  methodTypes,
} from '../../../common/utils/api_utils';
import * as actions from '../redux/actions';
import { processData } from '../../../common/utils/rest_utils';
import CollectionMappingForm from '../CollectionMappingForm';
import { drapcodeIcon, iconForField } from '../../../common/custom/icon-library';
import CustomRadio from '../../../common/ui/CustomRadio';
import ExternalSourceBodyJSON from './ExternalSourceBodyJSON';
import RestAPICollectionFieldsModal from '../rest-api/RestAPICollectionFieldsModal';
import { showAlertHtml } from '../../../common/utils/alert';
import { showErrorHtml } from '../../../common/utils/error';
import ExternalBodyCollectionMapping from './ExternalBodyCollectionMapping';
import TooltipInfo from '../../../common/docs/TooltipInfo';
export class ExternalSourceCollectionMapping extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedCollection: null,
    requestDataJsonType: 'DEFAULT',
    toggleFields: false,
  };

  componentDidMount = () => {
    const { home, selectedCollectionName, bodyDataFrom, sendCollectionData } = this.props;
    const { collections } = home;
    const selectedCollection = collections.find((collection) => {
      return collection.collectionName === selectedCollectionName;
    });

    if (!selectedCollection || selectedCollection !== 'undefined') {
      this.setState({ selectedCollection });
    }
  };

  shouldComponentUpdate = (nextProps, nextState, nextContext) => {
    const { home, selectedCollectionName } = this.props;
    const { collections } = home;
    if (selectedCollectionName !== nextProps.selectedCollectionName) {
      const selectedCollection = collections.find((collection) => {
        return collection.collectionName === nextProps.selectedCollectionName;
      });

      if (!selectedCollection || selectedCollection !== 'undefined') {
        this.setState({ selectedCollection });
      }
    }
    return true;
  };

  createNewCollectionMappingRow = (rowObj) => {
    const collectionMapping = processData(this.props.collectionMapping, rowObj);
    this.props.handleChange('collectionMapping', collectionMapping);
  };

  createNewBodyCollectionMappingRow = (rowObj) => {
    const bodyCollectionMapping = processData(this.props.bodyCollectionMapping, rowObj);
    this.props.handleChange('bodyCollectionMapping', bodyCollectionMapping);
  };

  collectionsOptions = () => {
    const { collections, inMemoryCollections } = this.props.home;
    let collectionsToSelect = [];
    if (collections && collections.length > 0) {
      collectionsToSelect = collections.sort(dynamicSort('collectionTitle')).map((e) => ({
        label: e.collectionTitle,
        value: e.collectionName,
      }));
    }

    return [...collectionsToSelect];
  };

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    if (name === 'bodyDataFrom') {
      const { selectedCollection } = this.state;
      const { sendCollectionData } = this.props;
      const isPersistent = selectedCollection && selectedCollection.willPersist;
      const confirmationMsg = isPersistent
        ? `<strong>This is a Persistent Collection.</strong><br><br>${
            checked ? 'Enabling' : 'Disabling'
          } the Data From External Source will make system to fetch data from ${
            checked ? 'External database' : 'Default database'
          }.<br><br>Do you want to proceed?`
        : `<strong>This is a Non-Persistent Collection.</strong><br><br>${
            checked ? 'Enabling' : 'Disabling'
          } the Data From External Source will make system to fetch data from ${
            checked ? 'External database' : 'Default database'
          }.<br><br>Do you want to proceed?`;

      if (checked) {
        const preConfirm = () => {
          this.props.handleChange(name, 'NON_PERSISTENT_COLLECTION');
        };
        showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
      } else {
        const preConfirm = () => {
          this.props.handleChange(name, 'collectionItem');
        };
        showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
      }
    } else {
      this.props.handleChange(name, value);
    }
  };

  showCollectionTypeInfo = () => {
    const warningMsg = `<strong>This is a Non-Persistent Collection.</strong><br><br>You cannot unselect the Data From External Source checkbox`;
    showErrorHtml(warningMsg, 'warning');
  };

  handleJsonTypeChange = (event) => {
    const requestDataJsonType = event.target.value;
    this.setState({ requestDataJsonType });
    this.props.handleChange('requestDataJsonType', event.target.value);
  };

  jsonEditorMounted = (editor) => {
    this.props.handleJsonEditor(editor);
    editor.focus();
  };

  toggleFieldsModal = () => {
    this.setState({ toggleFields: !this.state.toggleFields });
  };

  copyToClipboard = () => {
    this.setState({ copied: true, toggleFields: !this.state.toggleFields });
    toast.success('Copied to clipboard');
    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };

  insertTextToEditor = (textToInsert) => {
    this.setState({ toggleFields: !this.state.toggleFields });
    toast.success('Inserted into editor');
    if (textToInsert) {
      const editor = this.props.jsonEditor;
      const range = editor.selection.getRange();
      editor.session.replace(range, `"${textToInsert}"`);
    }
  };

  showCollectionFieldModal = () => {
    const { selectedCollection } = this.state;
    const { home, bodyDataFrom, projectDetail } = this.props;
    const { collections } = home ? home : '';
    return (
      <RestAPICollectionFieldsModal
        selectedCollection={selectedCollection}
        collections={collections}
        projectDetail={projectDetail}
        copyToClipboard={this.copyToClipboard}
        insertTextToEditor={this.insertTextToEditor}
        toggleFields={this.state.toggleFields}
        toggleFieldsModal={this.toggleFieldsModal}
        bodyDataFrom={bodyDataFrom}
      />
    );
  };

  showMappingForm = () => {
    const { selectedCollection } = this.state;
    const {
      externalApiType,
      home,
      collectionMapping,
      toggleSendFormData,
      sendFormData,
      bodyCustomJSON,
      handleBodyCustomJSON,
      jsonEditor,
      highlightFields,
      bodyCollectionMapping,
    } = this.props;

    if (selectedCollection && this.props.requestDataJsonType === 'DEFAULT') {
      const image = apiTypeImages[externalApiType];
      return (
        <>
          <div className="row mx-auto mt-5">
            <div className="col-12 text-center">
              <div className="row mx-auto">
                <div className="col-md-6 col-lg-6 col-sm-6 align-middle text-left">
                  <h5 className="border-bottom" style={{ lineHeight: '1.75em' }}>
                    {externalApiType ? (
                      <img
                        src={require(`../../../common/dataSource/img/${image}`)}
                        width="18"
                        height="18"
                        className="no-wh"
                        alt={
                          externalApiType === REST_API
                            ? 'REST API'
                            : snakeCaseToTitleCase(externalApiType)
                        }
                      />
                    ) : (
                      <i className={`wb ${drapcodeIcon('REST_API')}`}></i>
                    )}
                    &nbsp;
                    {externalApiType
                      ? externalApiType === REST_API
                        ? 'REST API'
                        : snakeCaseToTitleCase(externalApiType)
                      : 'Request'}
                    &nbsp;Fields
                  </h5>
                </div>
                <div className="col-md-6 col-lg-6 col-sm-6 align-middle text-left">
                  <h5 className="border-bottom">
                    <i className={`wb ${drapcodeIcon('collection')}`}></i>&nbsp;Collection Fields
                  </h5>
                </div>
              </div>
              {collectionMapping &&
                collectionMapping.map((row) => {
                  return (
                    <CollectionMappingForm
                      selectedCollection={selectedCollection}
                      collections={home.collections}
                      key={row.id}
                      collectionMappingRow={row}
                      createNewCollectionMappingRow={this.createNewCollectionMappingRow}
                      externalApiType={externalApiType}
                      projectDetail={home.projectDetail}
                    />
                  );
                })}
            </div>
          </div>
          <div className="col-12 mt-5">
            <hr></hr>
            <div className="form-group mt-4">
              <div className="form-check">
                <CustomRadio
                  label="Send Form Data along with Request Mapped Fields"
                  isRadio={false}
                >
                  <input
                    name="sendFormData"
                    type="checkbox"
                    className="form-check-input"
                    checked={sendFormData}
                    onChange={(e) => toggleSendFormData(e)}
                  />
                </CustomRadio>
                <br />
                <small>( We will send form data along with request mapped fields.)</small>
              </div>
            </div>
          </div>
        </>
      );
    } else if (this.props.requestDataJsonType === 'CUSTOM') {
      return (
        <>
          <div className="col-12 px-0">
            <div>
              <h4>
                <small>Raw Body JSON ( Note: It'll override the request body content )</small>
              </h4>
              {selectedCollection && (
                <>
                  <button
                    type="button"
                    className="btn btn-theme-submit btn-sm"
                    onClick={() => {
                      this.setState({ toggleFields: !this.state.toggleFields });
                    }}
                  >
                    <i className="wb webconnect-eye" />
                    &nbsp;<span>Insert Fields</span>
                  </button>
                </>
              )}
              {bodyCustomJSON && (
                <>
                  {' '}
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-xs btn-icon-only"
                    title="Highlight Dynamic Fields in Editor"
                    onClick={() => {
                      this.props.toggleHighlightFields(jsonEditor, 'BODY_JSON');
                    }}
                  >
                    <i className="wb webconnect-binoculars" />
                  </button>
                </>
              )}
            </div>
            <ExternalSourceBodyJSON
              params={this.props.params}
              bodyJSON={bodyCustomJSON}
              handleBodyJSON={handleBodyCustomJSON}
              jsonEditorMounted={this.jsonEditorMounted}
              highlightFields={highlightFields}
            />
          </div>
        </>
      );
    } else if (this.props.requestDataJsonType === 'FORM_DATA') {
      const image = apiTypeImages[externalApiType];
      return (
        <>
          <div className="row mx-auto mt-5">
            <div className="col-12 text-center">
              <div className="row mx-auto">
                <div className="col-md-6 col-lg-6 col-sm-6 align-middle text-left">
                  <h5 className="border-bottom" style={{ lineHeight: '1.75em' }}>
                    {externalApiType ? (
                      <img
                        src={require(`../../../common/dataSource/img/${image}`)}
                        width="18"
                        height="18"
                        className="no-wh"
                        alt={
                          externalApiType === REST_API
                            ? 'REST API'
                            : snakeCaseToTitleCase(externalApiType)
                        }
                      />
                    ) : (
                      <i className={`wb ${drapcodeIcon('REST_API')}`}></i>
                    )}
                    &nbsp;
                    {externalApiType
                      ? externalApiType === REST_API
                        ? 'REST API'
                        : snakeCaseToTitleCase(externalApiType)
                      : 'Response'}
                    &nbsp;Fields
                  </h5>
                </div>
                <div className="col-md-6 col-lg-6 col-sm-6 align-middle text-left">
                  <h5 className="border-bottom">
                    <i className={`wb ${drapcodeIcon('collection')}`}></i>&nbsp;Collection Fields
                  </h5>
                </div>
              </div>
              {bodyCollectionMapping &&
                bodyCollectionMapping.map((row) => {
                  return (
                    <ExternalBodyCollectionMapping
                      selectedCollection={selectedCollection}
                      collections={home.collections}
                      key={row.id}
                      collectionMappingRow={row}
                      createNewCollectionMappingRow={this.createNewBodyCollectionMappingRow}
                      externalApiType={externalApiType}
                      projectDetail={home.projectDetail}
                      externalapi={this.props.externalapi}
                      bodyDataFrom={this.props.bodyDataFrom}
                      collectionName={this.props.selectedCollectionName}
                    />
                  );
                })}
            </div>
          </div>
          <div className="col-12 mt-5">
            <hr></hr>
            <div className="form-group mt-4">
              <div className="form-check">
                <CustomRadio
                  label="Send Form Data along with Request Mapped Fields"
                  isRadio={false}
                >
                  <input
                    name="sendFormData"
                    type="checkbox"
                    className="form-check-input"
                    checked={sendFormData}
                    onChange={(e) => toggleSendFormData(e)}
                  />
                </CustomRadio>
                <br />
                <small>( We will send form data along with request mapped fields.)</small>
              </div>
            </div>
          </div>
        </>
      );
    } else if (this.props.requestDataJsonType === 'FORM_URL_ENCODED') {
      const image = apiTypeImages[externalApiType];
      return (
        <>
          <div className="row mx-auto mt-5">
            <div className="col-12 text-center">
              <div className="row mx-auto">
                <div className="col-md-6 col-lg-6 col-sm-6 align-middle text-left">
                  <h5 className="border-bottom" style={{ lineHeight: '1.75em' }}>
                    {externalApiType ? (
                      <img
                        src={require(`../../../common/dataSource/img/${image}`)}
                        width="18"
                        height="18"
                        className="no-wh"
                        alt={
                          externalApiType === REST_API
                            ? 'REST API'
                            : snakeCaseToTitleCase(externalApiType)
                        }
                      />
                    ) : (
                      <i className={`wb ${drapcodeIcon('REST_API')}`}></i>
                    )}
                    &nbsp;
                    {externalApiType
                      ? externalApiType === REST_API
                        ? 'REST API'
                        : snakeCaseToTitleCase(externalApiType)
                      : 'Response'}
                    &nbsp;Fields
                  </h5>
                </div>
                <div className="col-md-6 col-lg-6 col-sm-6 align-middle text-left">
                  <h5 className="border-bottom">
                    <i className={`wb ${drapcodeIcon('collection')}`}></i>&nbsp;Collection Fields
                  </h5>
                </div>
              </div>
              {bodyCollectionMapping &&
                bodyCollectionMapping.map((row) => {
                  return (
                    <ExternalBodyCollectionMapping
                      selectedCollection={selectedCollection}
                      collections={home.collections}
                      key={row.id}
                      collectionMappingRow={row}
                      createNewCollectionMappingRow={this.createNewBodyCollectionMappingRow}
                      externalApiType={externalApiType}
                      projectDetail={home.projectDetail}
                      externalapi={this.props.externalapi}
                      bodyDataFrom={this.props.bodyDataFrom}
                      collectionName={this.props.selectedCollectionName}
                    />
                  );
                })}
            </div>
          </div>
          <div className="col-12 mt-5">
            <hr></hr>
            <div className="form-group mt-4">
              <div className="form-check">
                <CustomRadio
                  label="Send Form Data along with Request Mapped Fields"
                  isRadio={false}
                >
                  <input
                    name="sendFormData"
                    type="checkbox"
                    className="form-check-input"
                    checked={sendFormData}
                    onChange={(e) => toggleSendFormData(e)}
                  />
                </CustomRadio>
                <br />
                <small>( We will send form data along with request mapped fields.)</small>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return '';
    }
  };

  bodyDataOptions = () => {
    const { selectBodyDataFrom, requestDataJsonType } = this.props;

    const bodyOptions = [
      // { name: 'NO_BODY_DATA', label: 'No Data', desc: 'No Body Data will be sent.' },
      // {
      //   name: 'DEFAULT_FIELDS',
      //   label: 'All Fields',
      //   desc: 'Entire Collection Item data will be sent in Body Data.',
      // },
      // {
      //   name: 'DEFAULT',
      //   label: 'Custom Fields',
      //   desc: 'Send Selected Collection Fields in Body Data.',
      // },
      // {
      //   name: 'FORM_DATA',
      //   label: 'form-data',
      //   desc: 'Send Collection Fields as Form Data',
      // },
      // {
      //   name: 'FORM_URL_ENCODED',
      //   label: ' x-www-form-urlencoded',
      //   desc: 'Send Collection Fields as Url Encoded Form Data',
      // },
      {
        name: 'CUSTOM',
        label: 'Raw JSON',
        desc: 'Send Raw JSON data',
      },
    ];

    return bodyOptions.map((opt) => (
      <TooltipInfo
        key={opt.name}
        title={opt.desc}
        headerText={opt.label}
        showHeader={true}
        showArrow={true}
        append={true}
      >
        <label className="form-check-label mr-4">
          <input
            type="radio"
            className="form-check-input"
            name="requestDataJsonType"
            checked={requestDataJsonType === opt.name}
            onChange={(e) => selectBodyDataFrom('requestDataJsonType', opt.name)}
          />
          {opt.label}
          <span className="circle">
            <span className="check"></span>
          </span>
        </label>
      </TooltipInfo>
    ));
  };

  render() {
    const {
      bodyDataFrom,
      selectBodyDataFrom,
      highlightFields,
      bodyRawJSON,
      handleBodyRawJSON,
      jsonEditor,
      sendCollectionData,
      selectedCollectionName,
      selectedCollection,
      processResponseDataMapping,
      externalApiType,
    } = this.props;

    const { toggleFields } = this.state;
    const checkBoxDescription = '( Fetch data from External database )';
    const isPersistentCollection = selectedCollection && !!selectedCollection.willPersist;
    let isNonPersistent = false;
    if (isPersistentCollection) {
      if (sendCollectionData && bodyDataFrom === 'NON_PERSISTENT_COLLECTION') {
        isNonPersistent = true;
      }
    } else {
      isNonPersistent = true;
      if (sendCollectionData && bodyDataFrom !== 'NON_PERSISTENT_COLLECTION') {
        isNonPersistent = false;
      }
    }
    return (
      <>
        {toggleFields && this.showCollectionFieldModal()}
        <div className="row col-12 pb-2" style={{ justifyContent: 'space-between' }}>
          {processResponseDataMapping === 'AUTHENTICATION' ? (
            ''
          ) : (
            <Nav pills className="nav-pills-primary drapcode-nav-pills">
              {!sendCollectionData && (
                <>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: bodyDataFrom === 'noDynamicData' })}
                      onClick={() => {
                        selectBodyDataFrom('bodyDataFrom', 'noDynamicData');
                      }}
                    >
                      <i className="material-icons">block</i> No Dynamic Data
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: bodyDataFrom === 'formData' })}
                      onClick={() => {
                        selectBodyDataFrom('bodyDataFrom', 'formData');
                      }}
                    >
                      <i className="material-icons">article</i> Form Data
                    </NavLink>
                  </NavItem>
                </>
              )}
              {/* dont want to show client */}
              {/* {sendCollectionData && selectedCollectionName && (
              <>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: ['collectionItem', 'NON_PERSISTENT_COLLECTION'].includes(
                        bodyDataFrom,
                      ),
                    })}
                    onClick={() => {
                      selectBodyDataFrom('bodyDataFrom', 'collectionItem');
                    }}
                  >
                    <i className="material-icons">storage</i> Collection Data Mapping
                  </NavLink>
                </NavItem>
              </>
            )} */}
              {!sendCollectionData && (
                <NavItem>
                  <NavLink
                    className={classnames({ active: bodyDataFrom === 'RAW_JSON' })}
                    onClick={() => {
                      selectBodyDataFrom('bodyDataFrom', 'RAW_JSON');
                    }}
                  >
                    <i className="material-icons">integration_instructions</i> Custom JSON
                  </NavLink>
                </NavItem>
              )}
            </Nav>
          )}

          {sendCollectionData && selectedCollectionName && (
            <div className="d-none" style={{ marginTop: '20px' }}>
              <div className="form-check">
                {isPersistentCollection ? (
                  <>
                    <CustomRadio label="Data From External Source" isRadio={false}>
                      <input
                        name="bodyDataFrom"
                        type="checkbox"
                        className="form-check-input"
                        checked={isNonPersistent}
                        onChange={this.handleCheckboxChange}
                      />
                    </CustomRadio>
                    <small>{checkBoxDescription}</small>
                  </>
                ) : (
                  <>
                    <CustomRadio label="Data From External Source" isRadio={false}>
                      <input
                        name="bodyDataFrom"
                        type="checkbox"
                        className="form-check-input"
                        checked={isNonPersistent}
                        onChange={this.showCollectionTypeInfo}
                      />
                    </CustomRadio>
                    <small>{checkBoxDescription}</small>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
        {sendCollectionData &&
          selectedCollectionName &&
          !['noDynamicData', 'formData', 'urlQueryParams', 'RAW_JSON'].includes(bodyDataFrom) && (
            <>
              {['GET', 'DELETE'].includes(this.props.methodType) && externalApiType !== MYSQL ? (
                ''
              ) : (
                <div className="col-12 px-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="mx-auto pr-3">
                        <div className={`form-group`}>
                          <div className="input-group  d-none">
                            <div className="form-check">{this.bodyDataOptions()}</div>
                          </div>
                        </div>
                      </div>
                      {this.props.methodType &&
                      this.props.methodType === 'DELETE' &&
                      externalApiType !== MYSQL
                        ? ''
                        : this.showMappingForm()}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        {!sendCollectionData && ['RAW_JSON'].includes(bodyDataFrom) && (
          <>
            <div className="col-12 px-4">
              <div className="card">
                <div className="card-body">
                  <div className="col-12">
                    <h4>
                      <small>
                        Custom Body JSON ( Note: It'll override the request body content )
                      </small>
                    </h4>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-sm"
                      onClick={() => {
                        this.setState({ toggleFields: !this.state.toggleFields });
                      }}
                    >
                      <i className="wb webconnect-eye" />
                      &nbsp;<span>Insert Fields</span>
                    </button>
                    {bodyRawJSON && (
                      <>
                        {' '}
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-xs btn-icon-only"
                          title="Highlight Dynamic Fields in Editor"
                          onClick={() => {
                            this.props.toggleHighlightFields(jsonEditor, 'RAW_JSON');
                          }}
                        >
                          <i className="wb webconnect-binoculars" />
                        </button>
                      </>
                    )}
                  </div>
                  <ExternalSourceBodyJSON
                    params={this.props.params}
                    bodyJSON={bodyRawJSON}
                    handleBodyJSON={handleBodyRawJSON}
                    jsonEditorMounted={this.jsonEditorMounted}
                    highlightFields={highlightFields}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalSourceCollectionMapping);
